<template>
  <div class="page-container">
    <div class="header">
      <div class="title">结算回执单管理</div>
    </div>

    <div class="search-area">
      <el-form inline>
        <template v-for="(item, index) in searchConfig">
          <el-form-item
            :key="index"
            :label="item.label"
            :label-width="`${22 * (item.label ? item.label.length : 1)}px`"
            size="small"
            v-if="!item.needHeadShop || isHeadShop"
          >
            <el-input v-if="item.kind === 'input'" v-model="searchForm[item.bind]" class="search-input" :placeholder="`请输入${item.label}`" />
            <el-select
              v-else-if="item.kind === 'select'"
              v-model="searchForm[item.bind]"
              class="search-input"
              :filterable="item.filterable || false"
              :placeholder="`请选择${item.label}`"
            >
              <el-option v-if="!item.filterable" label="全部" value="" />
              <el-option v-for="(value, key, index) in item.options" :key="index" :value="Number(key)" :label="value" />
            </el-select>
            <CommonSelect
              v-else-if="item.kind === 'commonSelect'"
              v-model="searchForm[item.bind]"
              :placeholder="`请选择${item.label}`"
              :needAll="true"
              :needPaging="true"
              :needRemote="true"
              :remoteConfig="item.remoteConfig"
            />
            <DateTimeRangePicker
              v-else-if="item.kind === 'date'"
              ref="dateRangePicker"
              :type="item.type"
              :shortcutArr="item.shortcutArr"
              :startTime.sync="searchForm[item.bind[0]]"
              :endTime.sync="searchForm[item.bind[1]]"
            />
          </el-form-item>
          <br :key="index + 'br'" v-if="item.withBr" />
        </template>
        <el-form-item size="small">
          <el-button class="bs-btn" :loading="table.loading" @click="handleSearch">查询</el-button>
          <el-button class="bs-btn" @click="getReceiptVisible = true">获取回执单</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-area">
      <el-table border style="width: 100%;" v-loading="table.loading" :data="table.data">
        <el-table-column
          v-for="(item, index) in table.columns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :min-width="item.minWidth || '180'"
          :formatter="item.formatter"
          align="center"
        />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row, $index}">
            <el-button type="text" :loading="row.downloadLoading" @click="handleDownload(row, $index)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="btm-action">
        <el-pagination
          v-if="table.count > 0"
          class="pagination"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.count"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage"
        />
      </el-col>
    </div>

    <el-dialog :visible.sync="getReceiptVisible" title="获取回执单" @close="handleGetReceiptDialogClose">
      <el-form label-width="120px" ref="getReceiptForm" :model="getReceiptForm">
        <el-form-item label="门店" prop="shopId" :rules="required('门店')">
          <CommonSelect
            v-model="getReceiptForm.shopId"
            placeholder="请选择门店"
            :needPaging="true"
            :needRemote="true"
            :remoteConfig="{ quickRemoteLabel: 'shop' }"
          />
        </el-form-item>
        <el-form-item label="结算日期" prop="startDate" :rules="required('结算日期')">
          <DateTimeRangePicker
            type="daterange"
            maxRange="31 day"
            :startTime.sync="getReceiptForm.startDate"
            :endTime.sync="getReceiptForm.endDate"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="bs-btn2" @click="handleGetReceiptDialogClose">取消</el-button>
        <el-button class="bs-btn" :loading="getReceiptLoading" @click="handleGetReceiptConfirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable object-curly-newline */
import DateTimeRangePicker from '@/components/dateTimeRangePicker.vue';
import CommonSelect from '@/components/CommonSelect.vue';
import { getReceipt, getReceiptList, downloadReceipt } from '@/api/payment';
import { downloadImgByCrossOriginUrl } from '@/utils/index';

export default {
  name: 'settlement-receipt',
  components: {
    DateTimeRangePicker,
    CommonSelect,
  },
  data() {
    return {
      // 枚举
      mapDownloadStatus: {
        0: '未下载',
        1: '已下载',
      },

      searchConfig: [
        { kind: 'date', label: '创建时间', bind: ['startTime', 'endTime'], type: 'daterange', shortcutArr: [] },
        { kind: 'input', label: '商户编号', bind: 'targetMerchantId', needHeadShop: true },
        { kind: 'commonSelect', label: '门店', bind: 'shopId', needHeadShop: true, remoteConfig: { quickRemoteLabel: 'shop' } }, // TODO 总店账号展示该查询条件，分店账号不展示该查询条件
        { kind: 'input', label: '回单编号', bind: 'receiptId' },
      ],
      searchForm: {
        startTime: '',
        endTime: '',
        targetMerchantId: '',
        shopId: '',
        receiptId: '',
      },

      table: {
        loading: false,
        columns: [
          { label: '创建时间', prop: 'createTime' },
          { label: '回单编号', prop: 'receiptId' },
          { label: '结算日期', prop: '', formatter: item => `${item.startDate} - ${item.endDate}` },
          { label: '状态', prop: 'status', formatter: item => this.mapDownloadStatus[item.status] },
          { label: '商户编号', prop: 'merchantId' },
          { label: '门店简称', prop: 'merchantName' },
        ],
        data: [],
        pageNo: 1,
        pageSize: 10,
      },

      getReceiptVisible: false,
      getReceiptLoading: false,
      getReceiptForm: {
        shopId: '',
        startDate: '',
        endDate: '',
      },
      required: label => ({ required: true, message: `请选择${label}`, trigger: 'blur' }),
    };
  },
  computed: {
    actualParams() {
      const { startTime, endTime } = this.searchForm;
      return {
        ...this.searchForm,
        startTime: startTime ? `${startTime} 00:00:00` : startTime,
        endTime: endTime ? `${endTime} 23:59:59` : endTime,
      };
    },
    loginInfo() {
      const str = localStorage.getItem('LOGIN_INFO');
      return JSON.parse(str);
    },
    isHeadShop() { // 当前是否为总店登录
      return this.loginInfo.shopType === 1;
    },
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableList();
    },

    handleSearch() {
      this.table.pageNo = 1;
      this.queryTableList();
    },

    handleReset() {
      this.searchForm = this.$options.data().searchForm;
      this.$refs.dateRangePicker[0].handleQuickTimePickerChange(0);
    },

    queryTableList() {
      console.log('queryTableList');
      this.table.loading = true;
      const { pageNo, pageSize } = this.table;
      getReceiptList({ ...this.actualParams, pageNo, pageSize }).then((res) => {
        const { code, msg, data } = res.data;
        if (String(code) === '0') {
          this.table.data = data.list;
          this.table.count = data.totalCount;
        }
      }).finally(() => { this.table.loading = false; });
    },

    handleDownload({ receiptId }, index) {
      downloadReceipt({ receiptId }).then((res) => {
        const { code, data } = res.data;
        if (String(code) === '0') {
          downloadImgByCrossOriginUrl(data);
          this.queryTableList();
        }
      });
    },

    handleGetReceiptDialogClose() {
      this.getReceiptVisible = false;
      this.$refs.getReceiptForm.resetFields();
      this.getReceiptForm = this.$options.data().getReceiptForm;
    },

    handleGetReceiptConfirm() {
      console.log('handleGetReceiptConfirm');
      this.$refs.getReceiptForm.validate((isValid) => {
        if (isValid) {
          this.getReceiptLoading = true;
          getReceipt({ ...this.getReceiptForm }).then((res) => {
            const { code, msg, data } = res.data;
            if (Number(code) === 0) {
              this.handleSearch();
              this.$message.success('获取成功');
              this.getReceiptVisible = false;
            }
          }).finally(() => { this.getReceiptLoading = false; });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background-color: #f7f7f7;

  .header {
    display: flex;
    align-items: center;
    height: 80px;
    padding-left: 50px;
    background-color: #fff;
    border-bottom: 1px solid #f2f3f3;

    .title {
      font-size: 18px;
      line-height: 80px;
      color: #333;
    }
  }

  .search-area {
    margin-top: 40px;
    margin-left: 40px;
  }

  .table-area {
    margin: 40px 40px 0;

    .btm-action {
      margin-top: 20px;
      text-align: center;
    }
  }

  .dialog-footer {
    text-align: center;
  }
}
</style>
